import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/Notifications.css";

export default function NotificationScreen() {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const mobileNo = localStorage.getItem("mobileNo");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (!mobileNo) return;

        const response = await apiClient.get("/notice-history", {
          params: { mobileNo },
        });

        if (response.data.status && Array.isArray(response.data.info)) {
          setNotifications(response.data.info);
        }
      } catch (err) {
        console.error("Notification API error:", err);
      }
    };

    fetchNotifications();
  }, [mobileNo]);

  return (
    <div className="mainhome-screen-wrapper">
      <div className="nnotification-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          &larr;
        </button>
        <h2>Notifications</h2>
      </div>

      <div className="nnotification-list">
        {notifications.map((item, index) => (
          <div className="nnotification-card" key={index}>
            <h4 className="nnotification-title">{item.title}</h4>
            <p className="nnotification-message">
              {item.msg.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}